import PropTypes from 'prop-types';

export const SelectOptionKeyType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export default PropTypes.shape({
    key: SelectOptionKeyType,
    label: PropTypes.node.isRequired,
    icon: PropTypes.string,
})
